import { Theme, createStyles, makeStyles } from '@forgeglobal/design-framework';

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    authHeader: {
      padding: theme.spacing(3, 5),
      '&:last-child': {
        paddingBottom: theme.spacing(3),
      },
      width: '100%',
    },
    cardHeader: {
      paddingTop: theme.spacing(4),
      paddingBottom: theme.spacing(4),
      '& .MuiCardHeader-action': {
        alignSelf: 'flex-start',
        margin: theme.spacing(0),
        [theme.breakpoints.down('md')]: {
          paddingTop: theme.spacing(2),
          marginLeft: theme.spacing(0),
        },
        [theme.breakpoints.up('md')]: {
          paddingTop: theme.spacing(0),
        },
      },
      [theme.breakpoints.down('md')]: {
        padding: theme.spacing(3, 3, 3, 3),
        alignItems: 'flex-start',
        flexDirection: 'column',
      },
      [theme.breakpoints.up('md')]: {
        padding: theme.spacing(3, 5, 3, 5),
        alignItems: 'center',
      },
    },
    headerWrapper: {
      display: 'flex',
      alignItems: 'center',
      paddingRight: theme.spacing(4),
    },
    headerText: {
      fontFamily: 'GT Walsheim, sans-serif',
      fontStyle: 'normal',
      fontWeight: 500,
      fontSize: 20,
      lineHeight: '28px',
      paddingRight: theme.spacing(1),
    },
    cardContent: {
      [theme.breakpoints.down('md')]: {
        padding: theme.spacing(2, 3),
      },
      [theme.breakpoints.up('md')]: {
        padding: theme.spacing(5, 5, 2),
      },
      '&:last-child': {
        paddingBottom: theme.spacing(1),
      },
      '& .MuiBox-root': {
        '&:last-child': {
          paddingBottom: theme.spacing(1),
        },
      },
    },
    container: {
      padding: theme.spacing(0, 1),
    },
    listItem: {
      borderBottom: 0,
      padding: 0,
      paddingBottom: 8,
      [theme.breakpoints.down('md')]: {
        flexDirection: 'column',
      },
      [theme.breakpoints.up('md')]: {
        flexDirection: 'row',
      },
    },
    title: {
      padding: theme.spacing(4.5, 3, 0.5),
    },
    loading: {
      padding: theme.spacing(2),
    },
    labelWrapper: {
      display: 'flex',
      alignItems: 'center',
      marginTop: theme.spacing(-0.5),
      [theme.breakpoints.down('md')]: {
        paddingRight: theme.spacing(2),
      },
      [theme.breakpoints.up('md')]: {
        paddingRight: theme.spacing(5),
      },
    },

    text: {
      paddingRight: theme.spacing(1),
    },
    infoWrapper: {
      display: 'flex',
    },
    infoIcon: {
      color: theme.palette.grey['350'],
    },
    tooltip: {
      background: theme.palette.grey[800],
      maxWidth: theme.spacing(28),
      padding: theme.spacing(1),
    },
    tooltipArrow: {
      color: theme.palette.grey[800],
    },
    tooltipTypography: {
      color: theme.palette.grey[100],
    },
  })
);
